function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
export var hasMobileImage = function hasMobileImage(image) {
  if (!image) return;
  if (_typeof(image) !== 'object') return;
  return Object.keys(image).length !== 0;
};